function isIE() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf("MSIE ");
  const trident = ua.indexOf("Trident/");
  return msie > 0 || trident > 0;
}

document.addEventListener("DOMContentLoaded", function() {
  window.lozad().observe();

  if (isIE()) {
    const cartSubmitInput = document.createElement("input");
    cartSubmitInput.setAttribute("name", "checkout");
    cartSubmitInput.setAttribute("type", "hidden");
    document.querySelector("#cart").appendChild(cartSubmitInput);
    document
      .querySelector("#checkout")
      .addEventListener("click", function(_event) {
        document.querySelector("#cart").submit();
      });
  }

  if (location.pathname.includes("/policies")) {
    const policyContainer = document.querySelector(
      ".shopify-policy__container",
    );
    policyContainer.classList.add("prose", "py-7");
  }
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (_event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = class {
  constructor(country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(
      options["hideElement"] || province_domid,
    );

    Shopify.addListener(
      this.countryEl,
      "change",
      Shopify.bind(this.countryHandler, this),
    );

    this.initCountry();
    this.initProvince();
  }
  initCountry() {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  }
  initProvince() {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  }
  countryHandler(_e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  }
  clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  }
  setOptions(selector, values) {
    for (var i = 0; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class CrossSellDrawer extends HTMLElement {
  constructor() {
    super();
    this.state = {
      isVisible: false,
      title: "",
      subtitle: "",
      description: "",
      image: "",
      link: "",
      primaryButton: {
        text: "製品を見る",
        onClick: null,
      },
      secondaryButton: {
        text: "買い物を続ける",
        onClick: null,
      },
    };
    this.render = this.render.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  connectedCallback() {
    this.render();
    this.setupEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  setupEventListeners() {
    this.unsubscribeOpen = window.eventBus.subscribe(
      "cross-sell-drawer:open",
      this.handleOpen,
    );
    this.unsubscribeClose = window.eventBus.subscribe(
      "cross-sell-drawer:close",
      this.handleClose,
    );
    this.addEventListener("click", this.handleClick.bind(this));
  }

  removeEventListeners() {
    this.unsubscribeOpen();
    this.unsubscribeClose();
    this.removeEventListener("click", this.handleClick);
  }

  setState(newState) {
    this.state = { ...this.state, ...newState };
    this.render();
  }

  handleClick(event) {
    const closeButton = event.target.closest('button[name="close"]');
    const overlay = event.target.closest("cross-sell-drawer-overlay");
    const primaryButton = event.target.closest("#primary-button");
    const secondaryButton = event.target.closest("#secondary-button");

    if (closeButton || overlay) {
      this.handleClose();
    } else if (primaryButton) {
      this.handleButtonClick(this.state.primaryButton.onClick);
    } else if (secondaryButton) {
      this.handleButtonClick(this.state.secondaryButton.onClick);
    }
  }

  handleButtonClick(onClick) {
    if (onClick && typeof onClick === "function") {
      onClick(this.state, this.handleClose.bind(this));
    }
  }

  handleOpen(data) {
    this.setState({
      isVisible: true,
      title: data.title || "",
      subtitle: data.subtitle || "",
      description: data.drawerDescription || "",
      image: data.image || "",
      link: data.link || "",
      primaryButton: {
        ...this.state.primaryButton,
        ...data.primaryButton,
      },
      secondaryButton: {
        ...this.state.secondaryButton,
        ...data.secondaryButton,
      },
    });
  }

  handleClose() {
    this.setState({ isVisible: false });
  }

  render() {
    const {
      isVisible,
      title,
      subtitle,
      description,
      image,
      primaryButton,
      secondaryButton,
    } = this.state;

    this.innerHTML = `
      <div class="fixed left-0 top-0 flex justify-end w-[100vw] h-full ${isVisible ? "!visible" : "invisible"} bg-[#12121280] transition-all" style="z-index: 1000;">
        <cross-sell-drawer-overlay class="block fixed top-0 right-0 bottom-0 left-0"></cross-sell-drawer-overlay>
        <div class="flex flex-col justify-between md:w-[36rem] md:max-w-[calc(100vw_-_3rem)] bg-white overflow-hidden transition-all h-[85vh] absolute w-full bottom-0 md:relative md:h-full rounded-tl-lg rounded-tr-lg md:rounded-none transform ${isVisible ? "!translate-y-0 md:!translate-x-0" : "translate-y-full md:translate-x-full"}">
          <div class="flex flex-col h-full">
            <div class="p-4 md:py-4 md:px-6 flex items-center border-[var(--color-neutral-500)] border-b">
              <div class="w-full">
                <h2 class="text-[16px] md:text-[20px] mb-1 md:mb-2 font-semibold font-inter block">${title}</h2>
                <p class="block line-clamp-2">${subtitle}</p>
              </div>
              <button name="close" class="rounded-full w-10 h-10 transform rotate-45">
                <svg width="24" height="24" viewBox="0 0 18 19" class="mx-auto" fill="var(--color-neutral-900)" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.25 9.03369H9.75V4.53369C9.75 4.33478 9.67098 4.14401 9.53033 4.00336C9.38968 3.86271 9.19891 3.78369 9 3.78369C8.80109 3.78369 8.61032 3.86271 8.46967 4.00336C8.32902 4.14401 8.25 4.33478 8.25 4.53369V9.03369H3.75C3.55109 9.03369 3.36032 9.11271 3.21967 9.25336C3.07902 9.39401 3 9.58478 3 9.78369C3 9.9826 3.07902 10.1734 3.21967 10.314C3.36032 10.4547 3.55109 10.5337 3.75 10.5337H8.25V15.0337C8.25 15.2326 8.32902 15.4234 8.46967 15.564C8.61032 15.7047 8.80109 15.7837 9 15.7837C9.19891 15.7837 9.38968 15.7047 9.53033 15.564C9.67098 15.4234 9.75 15.2326 9.75 15.0337V10.5337H14.25C14.4489 10.5337 14.6397 10.4547 14.7803 10.314C14.921 10.1734 15 9.9826 15 9.78369C15 9.58478 14.921 9.39401 14.7803 9.25336C14.6397 9.11271 14.4489 9.03369 14.25 9.03369Z" fill="var(--color-neutral-900)"></path>
                </svg>
              </button>
            </div>
            <div class="p-4 md:px-6 md:py-6 mb-auto overflow-auto">
              <img class="rounded-lg mb-4 md:mb-5" loading="lazy" src="${image}" alt="">
              <div class="cross-sell-drawer-richtext">${description}</div>
            </div>
            <div class="p-4 md:px-6 md:py-4 border-[var(--color-neutral-500)] border-t">
              <div class="flex gap-2">
                <button id="secondary-button" class="font-inter text-[16px] md:text-[20px] font-semibold flex-1 text-center text-[var(--color-primary-400)] bg-white rounded-full border-[var(--color-primary-400)] border-2">${secondaryButton.text}</button>
                <button id="primary-button" class="btn text-[16px] md:text-[20px] flex-1">${primaryButton.text}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define("cross-sell-drawer", CrossSellDrawer);

class StarRating extends HTMLElement {
  constructor() {
    super();
    this.props = { rating: 0, size: 13 };
    this.maxRating = 5;
    this.minRating = 1;
  }

  get star() {
    return `
      <svg class="mr-[2px]" width="${this.props.size}" height="${this.props.size}" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 8.10006C20.1 7.60006 19.7 7.00006 19.2 7.00006L13.5 6.20006L10.9 1.00006C10.8 0.800061 10.7 0.70006 10.5 0.60006C10 0.30006 9.4 0.50006 9.1 1.00006L6.6 6.20006L0.9 7.00006C0.6 7.00006 0.4 7.10006 0.3 7.30006C-0.1 7.70006 -0.1 8.30006 0.3 8.70006L4.4 12.7001L3.4 18.4001C3.4 18.6001 3.4 18.8001 3.5 19.0001C3.8 19.5001 4.4 19.7001 4.9 19.4001L10 16.7001L15.1 19.4001C15.2 19.5001 15.4 19.5001 15.6 19.5001C15.7 19.5001 15.7 19.5001 15.8 19.5001C16.3 19.4001 16.7 18.9001 16.6 18.3001L15.6 12.6001L19.7 8.60006C19.9 8.50006 20 8.30006 20 8.10006Z" fill="var(--color-critical-600)"/>
      </svg>
    `;
  }

  get emptyStar() {
    return `
      <svg class="mr-[2px]" width="${this.props.size}" height="${this.props.size}" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 7.67002C19.9368 7.48711 19.822 7.32645 19.6693 7.20753C19.5167 7.0886 19.3328 7.01652 19.14 7.00002L13.45 6.17002L10.9 1.00002C10.8181 0.830952 10.6902 0.688365 10.5311 0.588597C10.3719 0.488828 10.1878 0.435913 9.99998 0.435913C9.81212 0.435913 9.62806 0.488828 9.46889 0.588597C9.30971 0.688365 9.18186 0.830952 9.09998 1.00002L6.54998 6.16002L0.859977 7.00002C0.6749 7.02633 0.500902 7.10399 0.357728 7.22418C0.214554 7.34438 0.107937 7.5023 0.0499774 7.68002C-0.00307759 7.8537 -0.00783865 8.03854 0.0362052 8.21472C0.080249 8.39089 0.171435 8.55175 0.299977 8.68002L4.42998 12.68L3.42998 18.36C3.39428 18.5475 3.41297 18.7413 3.48385 18.9185C3.55473 19.0957 3.67483 19.2489 3.82998 19.36C3.98119 19.4681 4.15955 19.5319 4.34503 19.5443C4.5305 19.5567 4.71575 19.5171 4.87998 19.43L9.99998 16.76L15.1 19.44C15.2403 19.5192 15.3988 19.5606 15.56 19.56C15.7718 19.5608 15.9784 19.4942 16.15 19.37C16.3051 19.2589 16.4252 19.1057 16.4961 18.9285C16.567 18.7513 16.5857 18.5575 16.55 18.37L15.55 12.69L19.68 8.69002C19.8244 8.5677 19.9311 8.40693 19.9877 8.22637C20.0444 8.04582 20.0486 7.8529 20 7.67002ZM13.85 11.67C13.7327 11.7835 13.645 11.9239 13.5944 12.079C13.5439 12.2341 13.532 12.3993 13.56 12.56L14.28 16.75L10.52 14.75C10.3753 14.673 10.2139 14.6327 10.05 14.6327C9.88606 14.6327 9.72466 14.673 9.57998 14.75L5.81998 16.75L6.53998 12.56C6.56791 12.3993 6.55609 12.2341 6.50554 12.079C6.45499 11.9239 6.36725 11.7835 6.24998 11.67L3.24998 8.67002L7.45998 8.06002C7.62198 8.03749 7.77598 7.97556 7.90848 7.87967C8.04098 7.78379 8.14794 7.65686 8.21998 7.51002L9.99998 3.70002L11.88 7.52002C11.952 7.66686 12.059 7.79379 12.1915 7.88968C12.324 7.98556 12.478 8.04749 12.64 8.07002L16.85 8.68002L13.85 11.67Z" fill="#B1B1B1"/>
      </svg>
    `;
  }

  initProps() {
    this.props.rating = +this.getAttribute(":rating") ?? this.maxRating;
    this.props.size = this.getAttribute(":size") ?? "13";
  }

  connectedCallback() {
    this.initProps();
    this.render();
  }

  disconnectedCallback() { }

  render() {
    const ratingTemplate = this.getRatingTemplate(
      this.props.rating <= this.maxRating ? this.props.rating : this.maxRating,
    );
    const wrapper = document.createElement("div");
    wrapper.className = "flex items-center mb-[1px]";
    wrapper.innerHTML = ratingTemplate;
    this.appendChild(wrapper);
  }

  getRatingTemplate(rating) {
    let result = "";
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        result += this.star;
      } else {
        result += this.emptyStar;
      }
    }
    return result;
  }
}

customElements.define("star-rating", StarRating);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`,
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`,
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(_event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom",
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      ).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.productSlider = this.querySelector(".product-slider-box");

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((_entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / sliderItemsToShow[0].clientWidth,
    );
    if (this.productSlider) {
      this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 4;
    } else {
      this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    }
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    if (this.productSlider) {
      this.currentPage =
        Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) +
        4;
    } else {
      this.currentPage =
        Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) +
        1;
    }

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.renderProductInfo();
      this.updateVariantInput();
      this.updateCrosssell();
      // this.updateSingleCrosssell();
    }
  }

  updateSingleCrosssell() {
    const size = this.currentVariant.title.split("|")[0].trim();

    const isSingleSize = ["Twin", "Twin XL"].includes(size);

    const $2xFoamPillow = $(`addon-service[data-variant-id="44308529086602"]`);
    const $singleFoamPillow = $(
      `addon-service[data-variant-id="44308529053834"]`,
    );

    const $2xProxyCoolingPillow = $(
      `addon-service[data-variant-id="44308528496778"]`,
    );
    const $singleProxyCoolingPillow = $(
      `addon-service[data-variant-id="44308528464010"]`,
    );

    if (isSingleSize) {
      $2xFoamPillow.hide();
      $2xProxyCoolingPillow.hide();

      $singleFoamPillow.show();
      $singleProxyCoolingPillow.show();

      const isFoamPillowChecked = $2xFoamPillow
        .find(".addon-checkbox__input")
        .is(":checked");
      if (isFoamPillowChecked) {
        $2xFoamPillow.trigger("click");
      }

      const isCoolingPillowChecked = $2xProxyCoolingPillow
        .find(".addon-checkbox__input")
        .is(":checked");
      if (isCoolingPillowChecked) {
        $2xProxyCoolingPillow.trigger("click");
      }
    } else {
      $2xFoamPillow.show();
      $2xProxyCoolingPillow.show();

      $singleFoamPillow.hide();
      $singleProxyCoolingPillow.hide();

      const isFoamPillowChecked = $singleFoamPillow
        .find(".addon-checkbox__input")
        .is(":checked");
      if (isFoamPillowChecked) {
        $singleFoamPillow.trigger("click");
      }

      const isCoolingPillowChecked = $singleProxyCoolingPillow
        .find(".addon-checkbox__input")
        .is(":checked");
      if (isCoolingPillowChecked) {
        $singleProxyCoolingPillow.trigger("click");
      }
    }
  }

  updateCrosssell() {
    const size = this.currentVariant.title.split("|")[0].trim();

    const $protectorCrossell = $(
      `addon-service[data-product-id="7907000287370"]`,
    );

    if (!!$protectorCrossell.length) {
      const protectorId = $protectorCrossell.data("productId");

      const protectorData = JSON.parse(
        document.querySelector(
          `script#ProductJson-${protectorId}[type="application/json"]`,
        ).textContent,
      );

      const hasCompatibleSize = protectorData.variants.some((v) => {
        const variantSize = v.title.split("|")[0].trim();
        return variantSize === size;
      });

      if (!hasCompatibleSize) {
        $protectorCrossell.hide();
        const isChecked = $protectorCrossell
          .find(".addon-checkbox__input")
          .is(":checked");
        if (isChecked) {
          $protectorCrossell.trigger("click");
        }
      } else {
        $protectorCrossell.show();
      }
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader =
      this.stickyHeader || document.querySelector("sticky-header");
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
    }
    window.setTimeout(() => {
      parent
        .querySelector("li.product__media-item")
        .scrollIntoView({ behavior: "smooth" });
    });
  }

  updateURL() {
    const hasJointProduct = document.querySelector("joint-product-engine");

    if (
      !this.currentVariant ||
      this.dataset.updateUrl === "false" ||
      hasJointProduct
    )
      return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `.product-form-${this.dataset.section}, #product-form-installment`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');

      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }

      const selectEl = productForm.querySelector('select[name="id"]');

      if (selectEl) {
        selectEl.value = this.currentVariant.id;
        selectEl.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const originalPrice = this.currentVariant.compare_at_price / 100,
      price = this.currentVariant.price / 100,
      totalSaved = Math.max(0, originalPrice - price),
      priceInCurrency = currencyFormatter.format(price / 100),
      originalPriceInCurrency = currencyFormatter.format(originalPrice / 100);

    $("[data-sale-price]").text(priceInCurrency);
    if (totalSaved) $("[data-regular-price]").text(originalPriceInCurrency);

    const isAvail = !!this.currentVariant.available;

    const attrConfiguratorEl = $("#attribute-configurator");

    attrConfiguratorEl[isAvail ? "removeClass" : "addClass"](
      "attribute-configurator--unavailable",
    );

    console.log(this.currentVariant);

    const $qtySelector = $("[data-quantity-selector]");

    $qtySelector[isAvail ? "removeClass" : "addClass"]("opacity-0\t");

    $("[data-quantity-selector-input]").val(1);

    this.toggleAddButton(!isAvail, window.variantStrings.soldOut);
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.querySelector(
      `.product-form-${this.dataset.section}`,
    );

    if (!productForm) return;
    const addButton = productForm.querySelector('button[name="add"]');

    if (!addButton) return;

    const addButtonText = addButton.querySelector("[data-add-to-cart-text]");

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

/*bundle variant-select*/
class BundleVariantSelects extends VariantSelects {
  constructor() {
    super();
  }
}

customElements.define("bundle-variant-selects", BundleVariantSelects);

/*end of bundle varient*/

class YotpoReviewStarsStandalone extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const $element = $(this);
    const starRatingObserver = new MutationObserver(() => {
      starRatingObserver.disconnect();

      $element.find(".yotpo-bottomline .yotpo-clr").remove();

      const $reviewSource = $element.find(".yotpo-bottomline .text-m");
      $reviewSource
        .addClass("yotpo-review-source")
        .removeClass("text-m")
        .html("");

      const $starsContainer = $element.find(".yotpo-bottomline .yotpo-stars");
      const $scoreEl = $starsContainer.find(".sr-only");
      $scoreEl
        .removeClass("sr-only")
        .addClass("yotpo-rating-score")
        .text(parseFloat($scoreEl.text()))
        .detach()
        .insertAfter($starsContainer);

      $element.find(".yotpo-stars .yotpo-icon-star").replaceWith(`
        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.103 4.36677C12.6146 4.36677 13.0492 4.6798 13.2104 5.1643C13.3711 5.64738 13.211 6.15694 12.8026 6.46198L10.4151 8.24502L11.2058 11.1976C11.3391 11.6966 11.1437 12.199 10.7085 12.4776C10.271 12.7579 9.73151 12.7231 9.33217 12.3927L7.18683 10.612C7.07859 10.522 6.92108 10.522 6.81228 10.612L4.66779 12.3927C4.44875 12.5744 4.18757 12.6662 3.9241 12.6662C3.70677 12.6662 3.48831 12.6041 3.29063 12.477C2.85569 12.1985 2.66087 11.696 2.79445 11.1976L3.58457 8.24502L1.19769 6.46227C0.789246 6.15636 0.629168 5.64708 0.790098 5.16373C0.951028 4.67951 1.38568 4.36677 1.89695 4.36677H4.66323C4.78656 4.36677 4.89707 4.2893 4.93837 4.17423L5.90139 1.47973C6.06887 1.01033 6.5001 0.706985 6.99998 0.706985C7.49957 0.706985 7.9308 1.01033 8.09828 1.48001L9.06215 4.17451C9.10316 4.28959 9.21368 4.36677 9.33672 4.36677H12.103Z" fill="var(--color-critical-600)"/>
        </svg>
      `);

      $element.find(".yotpo-stars .yotpo-icon-half-star").replaceWith(`
        <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.8471 3.93846C12.3799 3.93846 12.8326 4.27533 13.0005 4.79672C13.1678 5.31658 13.0011 5.86494 12.5757 6.19322L10.0891 8.11203L10.9126 11.2894C11.0515 11.8264 10.8479 12.3671 10.3946 12.6669C9.93897 12.9685 9.37709 12.9311 8.96117 12.5756L6.72671 10.6592C6.72671 11.0234 6.5 0 6.72671 0.0158723C7.17838 0.0747844 7.51955 0.378499 7.67603 0.83189L8.67993 3.73156C8.72265 3.8554 8.83775 3.93846 8.96591 3.93846H11.8471Z" fill="#CDCDCD"/>
          <path d="M5.38787 0.831589C5.55752 0.340325 6.21198 0.0332128 6.72671 0.0158723V10.6592C6.72671 10.6592 6.44993 10.5623 6.3366 10.6592L4.10303 12.5756C3.8749 12.7711 3.60286 12.8698 3.32845 12.8698C3.10209 12.8698 2.87456 12.803 2.66867 12.6663C2.21566 12.3665 2.01275 11.8258 2.15188 11.2894L2.97482 8.11203L0.488791 6.19352C0.0633806 5.86432 -0.103347 5.31627 0.0642677 4.7961C0.231883 4.27502 0.684591 3.93846 1.2171 3.93846H4.09828C4.22674 3.93846 4.34184 3.85509 4.38486 3.73126L5.38787 0.831589Z" fill="var(--color-critical-600)"/>
        </svg>
      `);
    });

    $(document).ready(async () => {
      starRatingObserver.observe(this.querySelector(".yotpo.bottomLine"), {
        childList: true,
        subtree: true,
      });
    });
  }
}

customElements.define(
  "yotpo-review-stars-standalone",
  YotpoReviewStarsStandalone,
);

function calculateCountdownTime(endTime) {
  const endDate = new Date(endTime).getTime();
  const currentTime = new Date().getTime();
  const timeRemaining = endDate - currentTime;

  return {
    days: Math.floor(timeRemaining / 1000 / 60 / 60 / 24),
    hours: Math.floor(timeRemaining / 1000 / 60 / 60) % 24,
    minutes: Math.floor(timeRemaining / 1000 / 60) % 60,
    seconds: Math.floor(timeRemaining / 1000) % 60,
  };
}

class Countdown {
  constructor(expiredDate, onRender, onComplete) {
    this.setExpiredDate(expiredDate);

    this.onRender = onRender;
    this.onComplete = onComplete;
  }

  setExpiredDate(expiredDate) {
    const currentTime = new Date().getTime();

    this.timeRemaining = expiredDate - currentTime;

    this.timeRemaining > 0 ? this.start() : this.complete();
  }

  complete() {
    if (typeof this.onComplete === "function") {
      this.onComplete();
    }
  }

  start() {
    this.update();

    const intervalId = setInterval(() => {
      this.timeRemaining -= 1000;
      if (this.timeRemaining < 0) {
        this.complete();
        clearInterval(intervalId);
      } else {
        this.update();
      }
    }, 1000);
  }

  getTime() {
    return {
      days: Math.floor(this.timeRemaining / 1000 / 60 / 60 / 24),
      hours: Math.floor(this.timeRemaining / 1000 / 60 / 60) % 24,
      minutes: Math.floor(this.timeRemaining / 1000 / 60) % 60,
      seconds: Math.floor(this.timeRemaining / 1000) % 60,
    };
  }

  update() {
    if (typeof this.onRender === "function") {
      this.onRender(this.getTime());
    }
  }
}

class HeroBannerCountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.digitElements = Array.from(this.querySelectorAll(".digit"));
    this.startTime = Date.now();
    this.endTime = null;
  }

  connectedCallback() {
    this.endTime = new Date(this.getAttribute("end-time").replace(" ", "T"));
    this.startTimer();
    setTimeout(() => {
      this.style.display = "block";
    }, 1000);
  }

  disconnectedCallback() { }

  setValues(values) {
    if (values.length !== this.digitElements.length) {
      console.error("Invalid values provided.");
      return;
    }

    values.forEach((value, index) => {
      this.digitElements[index].textContent = value;
    });
  }

  renderTimer(delta) {
    const timeParts = getTimeParts(delta);
    this.setValues(timeParts);
  }

  startTimer() {
    const intervalId = setInterval(() => {
      const delta = (this.endTime - Date.now()) / 1000;
      if (delta >= 0) {
        this.renderTimer(delta);
      } else {
        this.classList.add("hidden");

        clearInterval(intervalId);
      }
    }, 1000);
  }
}

customElements.define("hero-banner-countdown-timer", HeroBannerCountdownTimer);

class PaidyPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
    this.hidePopover();
    this.querySelector('button[name="close"]').addEventListener(
      "click",
      this.hidePopover.bind(this),
    );
  }

  disconnectedCallback() { }

  showPopover() {
    this.style.display = "block";
  }

  hidePopover() {
    this.style.display = "none";
  }

  render() {
    this.innerHTML = `
        <div style="position: fixed !important;
      top: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      left: 0 !important;
      z-index: 2147483647 !important;
      background-color: #000 !important;
      opacity: 0.5 !important;"></div>
  <div style="position: fixed !important;
      top: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      left: 0 !important;
      z-index: 2147483647 !important;">
    <div style="position: absolute !important;
      
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
      -ms-transform: translate(-50%, -50%) !important;
      
      margin: 0 !important;
      padding: 0 !important;
      
      width: 100% !important;
      max-width: 640px !important;
      max-height: 100% !important;
      overflow: auto !important;
      overflow-y: auto !important;
      overflow-x: none !important;
      text-align: center !important;
      background-color: #fff !important;
      font-family: 'SF Pro JP', 'SF Pro Text', 'SF Pro Icons', 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !important;">
      <button name="close" style="display: block !important;
      position: absolute !important;
      top: 12px !important;
      right: 16px !important;">
        <img style="width: 32px !important; height: 32px !important;" src="https://cdn.paidy.com/promotional-messaging/general/images/close.svg" alt="Close">
      </button>
      <img style="margin: 24px auto 8px !important;
          
      width: 104px !important;
      height: auto !important;" src="https://cdn.paidy.com/promotional-messaging/general/images/paidy-text-color.svg">
      <h2 style="margin: 0 !important;
      font-family: 'SF Pro JP', 'SF Pro Text', 'SF Pro Icons', 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !important;
      font-size: 16px !important;
      line-height: 24px !important;
      font-weight: 600 !important;">あと払い（ペイディ）なら<br>3・6・12回あと払いが分割手数料無料*</h2>
      <hr style="margin: 16px auto !important;
      border: none !important;
      border-bottom: 1px solid #cfd4d8 !important;
      height: 0 !important;
      max-width: 328px !important;">
      <div style="position: relative !important;
      margin: 32px auto !important;
      width: 400px !important;">
        <img style="position: absolute !important;
      top: 0 !important;
      left: 0px !important;
      width: 48px !important;
      height: 48px !important;" src="https://cdn.paidy.com/promotional-messaging/general/images/1.svg" alt="1">
        <img style="display: inline !important;
      margin-top: 8px !important;
      width: 254px !important;" src="https://cdn.paidy.com/promotional-messaging/general/images/step-1.svg" alt="">
        <p style="font-size: 13px !important;
      color: #101825 !important;">お店のお支払方法で<br>「あと払い（ペイディ）」を選択して<br>一括払いで購入。</p>
      </div>
      <div style="position: relative !important;
      margin: 32px auto !important;
      width: 400px !important;">
        <img style="position: absolute !important;
      top: 0 !important;
      right: 0px !important;
      width: 48px !important;
      height: 48px !important;" src="https://cdn.paidy.com/promotional-messaging/general/images/2.svg" alt="2">
        <img style="display: inline !important;
      width: 172px !important;" src="https://cdn.paidy.com/promotional-messaging/general/images/step-2.svg" alt="">
        <p style="font-size: 13px !important;
      color: #101825 !important;">ペイディアプリをダウンロードして、<br>本人確認をする。</p>
      </div>
      <div style="position: relative !important;
      margin: 32px auto !important;
      width: 400px !important;">
        <img style="position: absolute !important;
      top: 0 !important;
      left: 0px !important;
      width: 48px !important;
      height: 48px !important;" src="https://cdn.paidy.com/promotional-messaging/general/images/3.svg" alt="3">
        <img style="display: inline !important;
      width: 252px !important;" src="https://cdn.paidy.com/promotional-messaging/general/images/step-3-12pay.svg" alt="">
        <p style="font-size: 13px !important;
      color: #101825 !important;">
          アプリでご希望の支払い回数に<br>変更して完了。
        </p>
      </div>
      <div style="padding: 32px !important;
      color: #2a2e32 !important;
      background-color: #f6f8fa !important;">
        <p style="margin: 8px auto !important;
      font-size: 12px !important;
      line-height: 16px !important;
      color: #2A2E32 !important;">
          *口座振替・銀行振込のみ無料
        </p>
        <p style="margin: 8px auto !important;
      font-size: 12px !important;
      line-height: 16px !important;
      color: #2A2E32 !important;">※別途審査があります</p>
      </div>
    </div>
  </div>
    `;
  }
}

customElements.define("paidy-popup", PaidyPopup);

class BlogItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tags = JSON.parse(this.dataset.tags);
  }

  disconnectedCallback() { }

  toggling(tag) {
    if (tag === "all") {
      this.style.display = "flex";
    } else {
      this.style.display = this.tags.includes(tag) ? "flex" : "none";
    }
  }
}

customElements.define("blog-item", BlogItem);

class BlogFilter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.blogs = [...document.querySelectorAll("blog-item")];
    this.querySelector("select").addEventListener(
      "change",
      this.handleFilterChange.bind(this),
    );
  }

  disconnectedCallback() { }

  handleFilterChange(event) {
    this.blogs.forEach((blog) => blog.toggling(event.target.value));
  }
}

customElements.define("blog-filter", BlogFilter);

class DeliveryDatePopup extends HTMLElement {
  super() { }

  connectedCallback() {
    this.hidePopover();
    this.querySelector('button[name="close"]').addEventListener(
      "click",
      this.hidePopover.bind(this),
    );
  }

  disconnectedCallback() { }

  showPopover() {
    this.style.display = "flex";
  }

  hidePopover() {
    this.style.display = "none";
  }
}

customElements.define("delivery-date-popup", DeliveryDatePopup);

class YotpoStarRatingOverride extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", () => {
      const reviewWidget = document.querySelector(".yotpo-widget-instance");
      reviewWidget?.scrollIntoView({ behavior: "smooth" });
    });
  }

  static StarTemplate = {
    fullStar:
      '<svg width="16" height="16" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" transform="scale(1.2, 1.2)"><defs><linearGradient id="yotpo_stars_gradient_0.6235855936637504"><stop offset="100%" stop-color="#e7721b"></stop><stop offset="100%" stop-color="var(--color-neutral-0)" stop-opacity="1"></stop></linearGradient></defs><path d="M17.0919 25.4549L16.8335 25.299L16.5751 25.4549L7.39263 30.9971L9.82942 20.5516L9.89798 20.2577L9.66988 20.0601L1.55658 13.0315L12.2393 12.1252L12.5397 12.0997L12.6574 11.8221L16.8335 1.9688L21.0096 11.8221L21.1273 12.0997L21.4277 12.1252L32.1104 13.0315L23.9971 20.0601L23.769 20.2577L23.8376 20.5516L26.2744 30.9971L17.0919 25.4549Z" stroke="#e7721b" fill="url(#yotpo_stars_gradient_0.6235855936637504)"></path></svg>',
    halfStar:
      '<svg width="16" height="16" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" transform="scale(1.2, 1.2)"><defs><linearGradient id="yotpo_stars_gradient_0.15281909476690947"><stop offset="51%" stop-color="#e7721b"></stop><stop offset="51%" stop-color="var(--color-neutral-0)" stop-opacity="1"></stop></linearGradient></defs><path d="M17.0919 25.4549L16.8335 25.299L16.5751 25.4549L7.39263 30.9971L9.82942 20.5516L9.89798 20.2577L9.66988 20.0601L1.55658 13.0315L12.2393 12.1252L12.5397 12.0997L12.6574 11.8221L16.8335 1.9688L21.0096 11.8221L21.1273 12.0997L21.4277 12.1252L32.1104 13.0315L23.9971 20.0601L23.769 20.2577L23.8376 20.5516L26.2744 30.9971L17.0919 25.4549Z" stroke="#e7721b" fill="url(#yotpo_stars_gradient_0.15281909476690947)"></path></svg>',
    emptyStar:
      '<svg width="16" height="16" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" transform="scale(1.2, 1.2)"><defs><linearGradient id="yotpo_stars_gradient_0.10280192260155174"><stop offset="0%" stop-color="#e7721b"></stop><stop offset="0%" stop-color="var(--color-neutral-0)" stop-opacity="1"></stop></linearGradient></defs><path d="M17.0919 25.4549L16.8335 25.299L16.5751 25.4549L7.39263 30.9971L9.82942 20.5516L9.89798 20.2577L9.66988 20.0601L1.55658 13.0315L12.2393 12.1252L12.5397 12.0997L12.6574 11.8221L16.8335 1.9688L21.0096 11.8221L21.1273 12.0997L21.4277 12.1252L32.1104 13.0315L23.9971 20.0601L23.769 20.2577L23.8376 20.5516L26.2744 30.9971L17.0919 25.4549Z" stroke="#e7721b" fill="url(#yotpo_stars_gradient_0.10280192260155174)"></path></svg>',
  };

  async connectedCallback() {
    const { ok, data } = await yotpoService.fetchRating(
      this.getAttribute("productId"),
    );
    if (ok) {
      const starData = this.createStarData(data);
      if (starData.reviewNumber > 0) {
        this.render(starData);
        this.style.display = "block";
      } else {
        this.style.display = "none";
      }
    } else {
      this.style.display = "none";
    }
  }

  createStarData(rawData) {
    const result = {};
    result.reviewNumber = rawData.bottomline.total_review;
    result.rating = rawData.bottomline.average_score;
    return result;
  }

  renderStars(rating) {
    return Array.from({ length: 5 }, (_, index) => {
      const starValue = index + 1;
      if (rating >= starValue) {
        return YotpoStarRatingOverride.StarTemplate.fullStar;
      } else if (rating > index && rating < starValue) {
        return YotpoStarRatingOverride.StarTemplate.halfStar;
      }

      return YotpoStarRatingOverride.StarTemplate.emptyStar;
    }).join("");
  }

  render(data) {
    this.innerHTML = `
      <div>
        <div class="flex items-center gap-2">
          <div class="grid gap-1 w-max grid-flow-col">${this.renderStars(data.rating)}</div>
          <div class="flex gap-1">
            <span class="!font-noto leading-none text-[14px] !text-[var(--color-neutral-900)] font-semibold">${data.rating.toFixed(1)}</span>
            <span class="!font-noto leading-none text-[14px] !text-[var(--color-neutral-900)] font-semibold">(${data.reviewNumber}件のレビュー)</span>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define("yotpo-star-rating-override", YotpoStarRatingOverride);

class YotpoStarRatingOverrideProductCard extends YotpoStarRatingOverride {
  constructor() {
    super();
    YotpoStarRatingOverrideProductCard.StarTemplate.fullStar =
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M13.8321 5.01629C14.4167 5.01629 14.9135 5.37404 15.0977 5.92775C15.2813 6.47984 15.0984 7.06219 14.6316 7.41082L11.903 9.44858L12.8067 12.8229C12.959 13.3932 12.7357 13.9675 12.2383 14.2858C11.7383 14.6061 11.1218 14.5664 10.6654 14.1888L8.21359 12.1537C8.08989 12.0508 7.90988 12.0508 7.78553 12.1537L5.33469 14.1888C5.08436 14.3965 4.78586 14.5013 4.48475 14.5013C4.23638 14.5013 3.98671 14.4303 3.76079 14.2852C3.26372 13.9668 3.04107 13.3926 3.19373 12.8229L4.09673 9.44858L1.36886 7.41115C0.902066 7.06154 0.719119 6.47951 0.903039 5.9271C1.08696 5.37371 1.58371 5.01629 2.16801 5.01629H5.32947C5.47043 5.01629 5.59673 4.92775 5.64393 4.79625L6.74451 1.71682C6.93592 1.18036 7.42876 0.833679 8.00005 0.833679C8.57101 0.833679 9.06385 1.18036 9.25525 1.71714L10.3568 4.79657C10.4037 4.92808 10.53 5.01629 10.6706 5.01629H13.8321Z" fill="var(--color-critical-600)"/></svg>';
  }

  render(data) {
    this.innerHTML = `
      <div class="flex items-center gap-1">
        ${YotpoStarRatingOverrideProductCard.StarTemplate.fullStar}
        <div class='flex'>
          <span class="text-xs dark:text-[var(--color-neutral-0)] leading-none font-semibold">${Math.round(data.rating * 10) / 10}</span>
          <span class="text-xs dark:text-[var(--color-neutral-0)] leading-none font-normal">(${data.reviewNumber})</span>
        </div>
      </div>
    `;
  }
}

customElements.define(
  "yotpo-star-rating-override-product-card",
  YotpoStarRatingOverrideProductCard,
);

class BlockCollapsibleRow extends HTMLElement {
  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    const button = this.querySelector(".collapsible-button");
    const content = this.querySelector(".collapsible-content");
    const caretIcon = this.querySelector(".caret-icon");

    if (button && content) {
      button.addEventListener("click", () => {
        const isOpen = content.classList.contains("opened");

        // Close all other open collapsible rows
        const allCollapsibleRows = document.querySelectorAll("collapsible-row");
        allCollapsibleRows.forEach((row) => {
          if (row !== this) {
            const otherContent = row.querySelector(".collapsible-content");
            const otherCaretIcon = row.querySelector(".caret-icon");
            if (otherContent && otherCaretIcon) {
              otherContent.classList.remove("opened", "pb-4");
              otherContent.classList.add("max-h-0", "overflow-hidden");
              otherCaretIcon.classList.remove("rotate-180");
            }
          }
        });

        // Toggle current collapsible row
        if (!isOpen) {
          content.classList.remove("max-h-0", "overflow-hidden");
          content.classList.add("opened", "pb-4");
          caretIcon.classList.add("rotate-180");
        } else {
          content.classList.remove("opened", "pb-4");
          content.classList.add("max-h-0", "overflow-hidden");
          caretIcon.classList.remove("rotate-180");
        }
      });
    }
  }
}

customElements.define("block-collapsible-row", BlockCollapsibleRow);



class LogoCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const sectionId = this.querySelector("section.logo-carousel").id;
    this.initLogoCarousel(sectionId);
  }

  renderAwardQuote(slide, sectionId) {
    if (slide.isClone) return;
    const awardHeadingEl = $(slide.slide).data("heading");
    const awardHeading = $($.parseHTML(awardHeadingEl)).text();
    $(`#${sectionId} .award-heading`).text(awardHeading);

    const awardQuoteEl = $(slide.slide).data("quote");
    const awardQuote = $($.parseHTML(awardQuoteEl)).text();
    $(`#${sectionId} .award-quote`).text(awardQuote);

    const awardSubQuoteEl = $(slide.slide).data("sub-quote");
    const awardSubQuote = $($.parseHTML(awardSubQuoteEl)).text();
    $(`#${sectionId} .award-sub-quote`).text(awardSubQuote);
  }

  async initLogoCarousel(sectionId) {
    await ResourceCoordinator.requestVendor("Splide");

    const awardCarousel = new Splide(`#${sectionId} .splide`, {
      gap: "1.6rem",
      type: "loop",
      perMove: 1,
      perPage: 5,
      pagination: false,
      arrows: true,
      focus: "center",
      breakpoints: {
        768: {
          perPage: 3,
          pagination: true,
          arrows: false,
        },
      },
    });

    awardCarousel.on("active", (slide) =>
      this.renderAwardQuote(slide, sectionId),
    );

    setTimeout(() => {
      awardCarousel.mount();
    });
  }
}

customElements.define("logo-carousel", LogoCarousel);

class LPRecommendationProductCard extends HTMLElement {
  constructor() {
    super();
    this.props = {
      product: {},
    };
  }

  initProps() {
    this.props.product = JSON.parse(this.getAttribute(":product"));
  }

  connectedCallback() {
    this.initProps();
    this.monitorMergedProductEvent();
  }

  monitorMergedProductEvent() {
    ProductPageStore.subscribe((event) => {
      const { currentProduct, currentVariant } = event.detail;
      if (currentProduct.handle === this.props.product.handle) {
        this.querySelector("lp-recommendation-product-card-price").render(
          currentVariant.price,
          currentVariant.compare_at_price,
        );
        this.classList.remove("hidden");
      } else {
        this.classList.add("hidden");
      }
    });
  }
}

customElements.define(
  "lp-recommendation-product-card",
  LPRecommendationProductCard,
);

class LPRecommendationProductCardPrice extends HTMLElement {
  constructor() {
    super();
  }

  render(price, compareAtPrice) {
    this.innerHTML = `
      <div class="flex flex-col gap-[6px]">
        ${compareAtPrice > price ? `<p class="text-[16px] text-[var(--color-neutral-900)] leading-none"><del>${currencyFormatter.format(compareAtPrice / 100)}</del></p>` : ""}
        <p class="text-[var(--color-negative-500)] text-[32px] font-semibold leading-none">${currencyFormatter.format(price / 100)}</p>
      </div>
    `;
  }
}

customElements.define(
  "lp-recommendation-product-card-price",
  LPRecommendationProductCardPrice,
);

class ComparisonChartPopupOpenButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(
      "button[data-comparison-chart-popup--open]",
    );
  }

  connectedCallback() {
    this.button.addEventListener("click", this.triggerOpenPopup.bind(this));
  }

  disconnectedCallback() {
    this.button.removeEventListener("click", this.triggerOpenPopup.bind(this));
  }

  triggerOpenPopup() {
    const event = new CustomEvent("open-comparison-popup");
    document.body.dispatchEvent(event);
  }
}

customElements.define(
  "comparison-chart-popup-open-button",
  ComparisonChartPopupOpenButton,
);

class CartFlashSale extends CustomElement {
  props = {
    targetDate: "",
    cartProductHandles: "",
    triggerProductHandles: "",
    eligibleMergedProducts: "",
  };

  constructor() {
    super();
  }

  get refs() {
    return {
      countdown: this.$el.find("[data-countdown-timer]"),
      day: this.$el.find("[data-day]"),
      hour: this.$el.find("[data-hour]"),
      minute: this.$el.find("[data-minute]"),
      second: this.$el.find("[data-second]"),
    };
  }

  beforeMount() {
    super.beforeMount();
  }

  mounted() {
    super.mounted();
    this.initSwiper();

    const { targetDate, triggerProductHandles, cartProductHandles } =
      this.props;
    const startTime = Date.now();
    const endTime = new Date(targetDate.replace(" ", "T"));

    let delta = (endTime - startTime) / 1000;

    this.tick(delta);
    this.$el.find("button[data-atc]").click(this.onAddFlashSale);

    setInterval(() => {
      delta -= 1;
      this.tick(delta);
    }, 1000);

    const triggerProducts = triggerProductHandles.split("|");
    const cartProducts = cartProductHandles.split("|");
    const isContaintTriggerProduct = triggerProducts.some((item) =>
      cartProducts.includes(item),
    );

    if (isContaintTriggerProduct) {
      this.$el.show();
    } else {
      this.$el.hide();
    }
  }

  async onAddFlashSale(e) {
    e.stopPropagation();
    const cartItems = document.getElementById("CartDrawerItems");
    const cartSummaryNode = document.getElementById("CartDrawerSummary");

    const $upsellItem = $(this).closest("cart-flash-sale-item");
    const $upsellVariantSelector = $upsellItem.find(".variant-selector select");

    const variantId = $upsellVariantSelector.find(":selected").val();

    const scrollableContentEl = $(this)
      .closest("cart-scrollable-content")
      .get(0);

    scrollableContentEl.loading = true;
    cartSummaryNode.loading = true;

    await cartItems.addToCart(variantId, 1, {});

    scrollableContentEl.loading = false;
    cartSummaryNode.loading = false;
  }

  tick(delta) {
    function pad(num, size) {
      num = num.toString();
      while (num.length < size) num = "0" + num;
      return num;
    }

    const { day, hour, minute, second } = this.refs;

    if (delta < 0) {
      this.$el.hide();
      document.getElementById("CartDrawerUpsell").classList.remove("hidden");
    }

    const timeParts = getTimeParts(delta);

    day.text(pad(timeParts[0], 2));
    hour.text(pad(timeParts[1], 2));
    minute.text(pad(timeParts[2], 2));
    second.text(pad(timeParts[3], 2));
  }

  async initSwiper() {
    const splide = this.querySelector(".splide");

    if (!splide) return;

    await ResourceCoordinator.requestVendor("Splide");

    new Splide(splide, {
      perPage: 1,
      perMove: 1,
      gap: "20px",
      pagination: false,
      arrows: true,
      breakpoints: {
        768: {
          perPage: 1,
          arrows: false,
          pagination: true,
          gap: "8px",
        },
      },
    }).mount();
  }
}

customElements.define("cart-flash-sale", CartFlashSale);

class BlockFlashSale extends CartFlashSale {
  constructor() {
    super();
  }

  mounted() {
    super.mounted();
    const { targetDate, eligibleMergedProducts } = this.props;
    const startTime = Date.now();
    const endTime = new Date(targetDate.replace(" ", "T"));

    let delta = (endTime - startTime) / 1000;

    this.tick(delta);
    this.$el.find("button[data-atc]").click(this.onAddFlashSale);

    setInterval(() => {
      delta -= 1;
      this.tick(delta);
    }, 1000);

    this.currentMergedProduct = ProductPageStore.getState().currentProduct;
    this.eligibleMergedProducts = eligibleMergedProducts?.split("|") ?? [];
    this.isMergedPDP = this.eligibleMergedProducts.length === 2;

    ProductPageStore.subscribe((event, prevState) => {
      this.currentMergedProduct = event.detail.currentProduct;
      this.refreshBlock();
    });

    GlobalStore.subscribe((event) => {
      this.refreshBlock();
    });

    this.refreshBlock();
  }

  refreshBlock() {
    const { targetDate } = this.props;
    const startTime = Date.now();
    const endTime = new Date(targetDate.replace(" ", "T"));
    const delta = endTime - startTime;

    if (delta <= 0) {
      this.$el.hide();
      return;
    }

    if (!this.isMergedPDP) {
      this.$el.show();
      return;
    }

    if (
      this.isMergedPDP &&
      this.eligibleMergedProducts.includes(this.currentMergedProduct.handle)
    ) {
      this.$el.show();
    } else {
      this.$el.hide();
    }
  }
}

customElements.define("block-flash-sale", BlockFlashSale);

class ProductCatalogFlashSale extends CartFlashSale {
  constructor() {
    super();
  }

  mounted() {
    super.mounted();
    const { targetDate } = this.props;
    const startTime = Date.now();
    const endTime = new Date(targetDate.replace(" ", "T"));

    let delta = (endTime - startTime) / 1000;

    this.tick(delta);
    this.$el.find("button[data-atc]").click(this.onAddFlashSale);

    setInterval(() => {
      delta -= 1;
      this.tick(delta);
    }, 1000);

    this.refreshBlock();
  }

  refreshBlock() {
    const { targetDate } = this.props;
    const startTime = Date.now();
    const endTime = new Date(targetDate.replace(" ", "T"));
    const delta = endTime - startTime;

    if (delta <= 0) {
      this.$el.hide();
    } else {
      this.$el.show();
    }
  }
}

customElements.define("product-catalog-flash-sale", ProductCatalogFlashSale);

class CartFlashSaleItem extends CustomElement {
  props = {
    saleValue: 0,
  };

  beforeMount() {
    super.beforeMount();
    const variantSelector = this.querySelector("variant-selector");
    if (variantSelector)
      variantSelector.addEventListener("change", this.refreshPrice.bind(this));
  }

  get refs() {
    return {
      originalPrice: this.$el.find("[data-original-price]"),
      salePrice: this.$el.find("[data-sale-price]"),
    };
  }

  refreshPrice() {
    const $selectedOption = this.$el.find(":selected");
    const { salePrice: salePriceElm, originalPrice: originalPriceElm } =
      this.refs;

    const price = $selectedOption.data("price");
    const priceInCurrency = currencyFormatter.format(price);
    const salePrice = (price * (100 - this.props.saleValue)) / 100;
    const salePriceInCurrency = currencyFormatter.format(salePrice);

    if (this.props.saleValue === 0) {
      originalPriceElm.hide();
    } else {
      originalPriceElm.show();
    }
    salePriceElm.text(salePriceInCurrency);
    originalPriceElm.text(priceInCurrency);
  }
}

customElements.define("cart-flash-sale-item", CartFlashSaleItem);
